// @ts-nocheck
import {
    BudgetDetailModel,
    BudgetDetailViewModel,
    BudgetSummaryModel,
    ExpenditureByProductModel,
    ExpendituresModel,
    InvoiceDetailModel,
    InvoiceDetailsModel,
    InvoiceSummaryModel,
    ManufacturersPickerModel,
    MonthlyExpenseComparisonModel,
    PoPickerModel,
    ReportOrderFrequencyModel,
    ServiceHistoryInvoiceModel,
    ServiceHistoryModel,
} from "@store/Framework/Services/Reporting/ReportingModels";
import {
    isBudgetDetailViewModel,
    isExpenditureByProductModel,
    isExpenditureByPurchaserModel,
    isExpendituresByManufacturersModel,
    isExpendituresModel,
    isInvoiceDetail,
    isInvoiceDetails,
    isInvoiceSummaryModel,
    isManufacturersPickerModel,
    isPoPickerModel,
    isReportOrderFrequencyModel,
    isServiceHistoryModel,
} from "@store/Framework/Services/Reporting/ReportingTypeGuards";
import { Dispatch } from "redux";

export const loadMonthlyExpenseComparison = (
    dispatch: Dispatch,
    apiResult: unknown,
): apiResult is MonthlyExpenseComparisonModel => {
    return true;
};
export const loadReportFrequency = (dispatch: Dispatch, apiResult: unknown): apiResult is ReportOrderFrequencyModel => {
    if (isReportOrderFrequencyModel(apiResult)) {
        dispatch({
            type: "Store/Pages/ReportOrderFrequency/CompleteLoadReportOrderFrequency",
            report: apiResult,
            parameter: apiResult,
        });
        return true;
    }
    return false;
};
export const loadInvoiceSummary = (dispatch: Dispatch, apiResult: unknown): apiResult is InvoiceSummaryModel => {
    if (isInvoiceSummaryModel(apiResult)) {
        dispatch({
            type: "Store/Pages/invoiceSummarys/LoadInvoiceSummary",
            report: apiResult,
            parameter: apiResult,
        });
        return true;
    }
    return false;
};

export const isMonthlyEpensiveComparisonModel = (apiResult: any): apiResult is MonthlyExpenseComparisonModel => {
    if (apiResult && "customers" in apiResult && apiResult.customers?.[0].items) {
        return "name" in apiResult.customers[0].items[0];
    }
    return false;
};

export const isBudgetSummaryModel = (apiResult: any): apiResult is BudgetSummaryModel => {
    if (apiResult) {
        if ("items" in apiResult && apiResult.items.length > 0) {
            return "jobnumber" in apiResult.items[0];
        }
    }
    return false;
};

export const isBudgetDetailModel = (apiResult: any): apiResult is BudgetDetailModel => {
    return isBudgetSummaryModel(apiResult);
};

export const isServiceHistoryInvoiceModel = (apiResult: any): apiResult is ServiceHistoryInvoiceModel => {
    if (apiResult) {
        return "division" in apiResult;
    }
    return false;
};

export const loadServiceHistoryInvoice = (
    dispatch: Dispatch,
    apiResult: unknown,
): apiResult is ServiceHistoryInvoiceModel => {
    return isServiceHistoryInvoiceModel(apiResult);
};
export const loadServiceHistory = (dispatch: Dispatch, apiResult: unknown): apiResult is ServiceHistoryModel => {
    return isServiceHistoryModel(apiResult);
};
export const loadBudgetSummary = (dispatch: Dispatch, apiResult: any): apiResult is BudgetSummaryModel => {
    return isBudgetSummaryModel(apiResult);
};

export const loadBudgetDetail = (dispatch: Dispatch, apiResult: any): apiResult is BudgetDetailModel => {
    return isBudgetDetailModel(apiResult);
};
export const loadPoPicker = (dispatch: Dispatch, apiResult: unknown): apiResult is PoPickerModel => {
    return isPoPickerModel(apiResult);
};

export const loadExpenditures = (dispatch: Dispatch, apiResult: unknown): apiResult is ExpendituresModel => {
    return isExpendituresModel(apiResult);
};

export const loadExpenditurebyPurchaser = (dispatch: Dispatch, apiResult: unknown) => {
    return isExpenditureByPurchaserModel(apiResult);
};

export const loadExpendituresByManufacturers = (dispatch: Dispatch, apiResult: unknown) => {
    return isExpendituresByManufacturersModel(apiResult);
};
export const loadExpenditureByProduct = (
    dispatch: Dispatch,
    apiResult: unknown,
): apiResult is ExpenditureByProductModel => {
    return isExpenditureByProductModel(apiResult);
};

export const loadBudgetDetailView = (dispatch: Dispatch, apiResult: unknown): apiResult is BudgetDetailViewModel => {
    return isBudgetDetailViewModel(apiResult);
};

export const loadManufacturers = (dispatch: Dispatch, apiResult: unknown): apiResult is ManufacturersPickerModel => {
    return isManufacturersPickerModel(apiResult);
};
export const loadInvoiceDetails = (dispatch: Dispatch, apiResult: unknown): apiResult is InvoiceDetailsModel => {
    return isInvoiceDetails(apiResult);
};

export const loadInvoiceDetail = (dispatch: Dispatch, apiResult: unknown): apiResult is InvoiceDetailModel => {
    if (isInvoiceDetail(apiResult)) {
        dispatch({
            type: "Store/Pages/invoiceDetail/LoadInvoiceDetail",
            report: apiResult,
            parameter: apiResult,
        });
        return true;
    }
    return false;
};
